export default __webpack_public_path__ + "static/media/virtual-card-bg.14013d85.png";